import * as Factory from 'factory.ts'
import faker from 'faker'

import { type CurrencyApiModel } from '../CurrencyApiModel'

export const CurrencyApiModelStub = Factory.Sync.makeFactory<CurrencyApiModel>({
  id: Factory.each(() => faker.random.number()),
  active: true,
  base: false,
  name: 'CAD',
  rate: faker.finance.amount(1, 100, 8),
})
